<template>
    <span>{{ prefix + time + suffix }}</span>
</template>

<script>
import moment from "moment";
import { mapState } from "vuex";

export default {
    name: "PassedTimeCounter",
    props: {
        date: {
            type: String,
            default: null,
        },
        prefix: {
            type: String,
            default: "",
        },
        suffix: {
            type: String,
            default: "",
        },
    },
    computed: mapState({
        timeDiff: (state) => state.auth.timeDiff,
    }),
    data() {
        return {
            time: 0,
            intervalTimerId: null,
            interval: 1000,
        };
    },
    methods: {
        start() {
            this.intervalTimerId = setInterval(this.incrementTime, this.interval);
        },
        incrementTime() {
            this.time = parseInt(this.time) + parseInt(this.interval / 1000);
        },
    },
    mounted() {
        if (this.date) {
            const diff = moment.duration(moment().add(this.timeDiff, "seconds").diff(moment(this.date)));
            this.time = parseInt(Math.floor(Math.max(diff.asSeconds(), 0)));
        }
        this.start();
    },
    beforeDestroy() {
        clearInterval(this.intervalTimerId);
    },
};
</script>

<style scoped></style>
